module.exports = __webpack_public_path__ + "static/media/3levelNormal.f42ee181.jpg";